import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface MinusIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const MinusIcon: React.FC<MinusIconProps> = ({ strokeWidth = 4, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-minus">
    <path
      d="M7 25 H43"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
    />
  </SvgIcon>
);

export default MinusIcon;


